import React from 'react';
import { Box } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';

import buttonHome from '../../../assets/icons/buttonHome.svg';
import buttonBack from '../../../assets/icons/buttonBack.svg';
import buttonNext from '../../../assets/icons/buttonNext.svg';
import disabledButtonNext from '../../../assets/icons/disabledButtonNext.svg';

interface NavigationButtonsProps {
  /** Whether the "Next" button is disabled */
  nextDisabled: boolean;
  /** Route for the "Next" button. Defaults to "/next". */
  nextRoute?: string;
  /** The home route. Defaults to "/home". */
  homeRoute?: string;
  nextVisible?: boolean;
}

export const NavigationButtons: React.FC<NavigationButtonsProps> = ({
  nextDisabled,
  nextRoute = '/next',
  nextVisible = true
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    // Takes the user to the previous page
    navigate(-1);
  };

  return (
    <Box
      sx={{
        margin: 'auto 0.625rem 0.625rem 0.625rem',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: nextVisible ? 'space-around' : 'flex-start',
        width: '200px',
        height: '60px',
        backgroundColor: '#fff',
        borderRadius: '100px'
      }}
    >
      {/* Back button: go back one page */}
      <Box component="button" onClick={handleBack} sx={buttonStyle}>
        <img src={buttonBack} alt="back" />
      </Box>

      {/* Home */}
      <Link
        to={'/'}
        style={{ ...linkStyle, marginLeft: !nextVisible ? '35px' : '0' }}
      >
        <img src={buttonHome} alt="home" />
      </Link>

      {/* Next (or disabled next) */}
      {nextVisible && nextDisabled ? (
        <Box sx={buttonStyle} component="span">
          <img src={disabledButtonNext} alt="next disabled" />
        </Box>
      ) : !nextVisible ? (
        <></>
      ) : (
        <Link to={nextRoute} style={linkStyle}>
          <img src={buttonNext} alt="next" />
        </Link>
      )}
    </Box>
  );
};

// Optional styling for the <button> or <Link>
const buttonStyle = {
  // Remove default button styling if you like:
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: 0,
  // Center the icon
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

const linkStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};
